import { Component, OnInit } from '@angular/core';
import { Router, RoutesRecognized, NavigationEnd } from '@angular/router';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { ProfileService } from '../profile.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  constructor(private router: Router, private profileService: ProfileService, private idle: Idle, private keepalive: Keepalive) {
        this.userProfile = { MAIN_MENU: [], CONTROL_PANEL: [], FULLNAME: '' };
        /*this.router.events.subscribe(event => {
            if (event instanceof RoutesRecognized) {
                this.activeRoute = event.url;
            }
            else if (event instanceof NavigationEnd) {
                // if u dont need the state, you could even use this event-type..
            }
        });
        idle.setIdle(600);
        idle.setTimeout(20);
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        idle.onTimeout.subscribe(() => {
            this.reset();
            this.signOut();
        });
        keepalive.interval(30);
        this.reset();*/
    }
    activeRoute: string;
    isLogin: boolean;
    loading: boolean;
    userProfile: any;
    
    signOut() {
        sessionStorage.removeItem('authorizationData');
        sessionStorage.removeItem('profile');
        this.isLogin = false;
        this.router.navigate(['/login']);
    }
    reset() {
        this.idle.watch();
    }

  ngOnInit() {
      var profile = JSON.parse(sessionStorage.getItem('profile'));
      if(profile==undefined){
        this.signOut();
      }else{
          this.profileService.getProfileInfo();
          this.userProfile = this.profileService.userProfile;
      }
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/main/main.component.ts